"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("../Button"));
var _Tooltip = _interopRequireDefault(require("../Tooltip"));
var _ConditionalWrapper = _interopRequireDefault(require("../ConditionalWrapper"));
var _keys = require("../utils/keys");
var _excluded = ["option", "expanded", "depth", "onOptionRemove", "onOptionAdd"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* babel-plugin-inline-import './icon-collapsed.svg' */
var collapsedIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgNSAxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNC41NCA0Ljc5M2wtNC0zLjg1Qy4zNzguNzg5LjEyNS45MTUuMTI1IDEuMTV2Ny43YzAgLjIzNi4yNTMuMzYyLjQxNS4yMDZsNC0zLjg1YS4yOTMuMjkzIDAgMDAwLS40MTN6IiBmaWxsPSIjQTBBMEEwIiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L3N2Zz4=";
/* babel-plugin-inline-import './icon-expanded.svg' */
var expandedIcon = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNSIgaGVpZ2h0PSI1IiB2aWV3Qm94PSIwIDAgMTAgNSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS4yMDcgNC41NGwzLjg1LTRjLjE1NS0uMTYyLjAyOS0uNDE1LS4yMDctLjQxNWgtNy43Qy45MTQuMTI1Ljc4OC4zNzguOTQ0LjU0bDMuODUgNGMuMTA5LjExMy4zMDMuMTEzLjQxMyAweiIgZmlsbD0iI0EwQTBBMCIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+";
/* babel-plugin-inline-import './Plus-Outline.svg' */
var plusOutline = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5HcmFwaGljIC8gSWNvbiAvIFRvZ2dsZSAvIFBsdXMgLyBPdXRsaW5lPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IkdyYXBoaWMtLy1JY29uLS8tVG9nZ2xlLS8tUGx1cy0vLU91dGxpbmUiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik0xMiwxIEMxOC4wNzUxMzIyLDEgMjMsNS45MjQ4Njc3NSAyMywxMiBDMjMsMTguMDc1MTMyMiAxOC4wNzUxMzIyLDIzIDEyLDIzIEM1LjkyNDg2Nzc1LDIzIDEsMTguMDc1MTMyMiAxLDEyIEMxLDUuOTI0ODY3NzUgNS45MjQ4Njc3NSwxIDEyLDEgWiBNMTIuMDAxMjQ3OSwyLjQ0ODg5NDE1IEM2LjcyNzAwNzA1LDIuNDQ4ODk0MTUgMi40NTEzOTAwMyw2LjcyNDUxMTE4IDIuNDUxMzkwMDMsMTEuOTk4NzUyMSBDMi40NTEzOTAwMywxNy4yNzI5OTMgNi43MjcwMDcwNSwyMS41NDg2MSAxMi4wMDEyNDc5LDIxLjU0ODYxIEMxNy4yNzU0ODg4LDIxLjU0ODYxIDIxLjU1MTEwNTgsMTcuMjcyOTkzIDIxLjU1MTEwNTgsMTEuOTk4NzUyMSBDMjEuNTUxMTA1OCw2LjcyNDUxMTE4IDE3LjI3NTQ4ODgsMi40NDg4OTQxNSAxMi4wMDEyNDc5LDIuNDQ4ODk0MTUgWiIgaWQ9Ik91dGVyIiBmaWxsPSIjQTBBMEEwIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4KICAgICAgICA8cGF0aCBkPSJNMTMsNi4wNjA2ODczNSBMMTIuOTk5LDEwLjk5OTY4NzMgTDE4LDExIEwxOCwxMyBMMTIuOTk5LDEyLjk5OTY4NzMgTDEzLDE4LjAwNjQ3MzIgTDExLDE4LjAwNjQ3MzIgTDEwLjk5OSwxMi45OTk2ODczIEw2LDEzIEw2LDExIEwxMC45OTksMTAuOTk5Njg3MyBMMTEsNi4wNjA2ODczNSBMMTMsNi4wNjA2ODczNSBaIiBpZD0iSW5uZXIiIGZpbGw9IiM2OTY5NkUiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4=";
/* babel-plugin-inline-import './Plus-Fill-Green.svg' */
var plusGreen = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDYwLjEgKDg4MTMzKSAtIGh0dHBzOi8vc2tldGNoLmNvbSAtLT4KICAgIDx0aXRsZT5HcmFwaGljIC8gSWNvbiAvIFRvZ2dsZSAvIFBsdXMgLyBGaWxsPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+CiAgICAgICAgPHBhdGggZD0iTTEyLDEgQzE4LjA3NTEzMjIsMSAyMyw1LjkyNDg2Nzc1IDIzLDEyIEMyMywxOC4wNzUxMzIyIDE4LjA3NTEzMjIsMjMgMTIsMjMgQzUuOTI0ODY3NzUsMjMgMSwxOC4wNzUxMzIyIDEsMTIgQzEsNS45MjQ4Njc3NSA1LjkyNDg2Nzc1LDEgMTIsMSBaIE0xMyw1Ljk4MzM5ODQ0IEwxMSw1Ljk4MzM5ODQ0IEwxMSwxMC45OTkzOTg0IEw2LDExIEw2LDEzIEwxMSwxMi45OTkzOTg0IEwxMSwxNy45OTg0MjY2IEwxMywxNy45OTg0MjY2IEwxMywxMi45OTkzOTg0IEwxOCwxMyBMMTgsMTEgTDEzLDEwLjk5OTM5ODQgTDEzLDUuOTgzMzk4NDQgWiIgaWQ9InBhdGgtMSI+PC9wYXRoPgogICAgPC9kZWZzPgogICAgPGcgaWQ9IkdyYXBoaWMtLy1JY29uLS8tVG9nZ2xlLS8tUGx1cy0vLUZpbGwiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxtYXNrIGlkPSJtYXNrLTIiIGZpbGw9IndoaXRlIj4KICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgICAgICA8L21hc2s+CiAgICAgICAgPHVzZSBpZD0iSWNvbiIgZmlsbD0iIzAwOTU3YSIgZmlsbC1ydWxlPSJub256ZXJvIiB4bGluazpocmVmPSIjcGF0aC0xIj48L3VzZT4KICAgIDwvZz4KPC9zdmc+";
var LEFT_PADDING = 15;
var Option = /*#__PURE__*/function (_PureComponent) {
  _inherits(Option, _PureComponent);
  var _super = _createSuper(Option);
  function Option() {
    var _this;
    _classCallCheck(this, Option);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "optionLabelRef", /*#__PURE__*/_react.default.createRef());
    _defineProperty(_assertThisInitialized(_this), "state", {
      expanded: !!_this.props.expandOptions,
      parentHeight: 0,
      showTooltip: false
    });
    _defineProperty(_assertThisInitialized(_this), "toggleExpanded", function () {
      return _this.setState({
        expanded: !_this.state.expanded
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onClickExpand", function (e) {
      e.stopPropagation();
      if (e.type === 'click') {
        e.preventDefault();
        return _this.toggleExpanded();
      }
      if (e.type === 'keydown' && _keys.SUBMIT_KEYS.has(e.key)) {
        e.preventDefault();
        return _this.toggleExpanded();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "isLabelOverflowing", function () {
      var currentOptionLabelRef = _this.optionLabelRef.current;
      if (!currentOptionLabelRef) return false;
      var offsetWidth = currentOptionLabelRef.offsetWidth,
        scrollWidth = currentOptionLabelRef.scrollWidth;
      return scrollWidth > offsetWidth;
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.setState({
        showTooltip: _this.isLabelOverflowing()
      });
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
      _this.setState({
        showTooltip: _this.isLabelOverflowing()
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onClickParent", function () {
      // stops drop down menu from closing.
      if (!_this.props.selectParents) {
        return _this.toggleExpanded();
      }
      var opt = _objectSpread({}, _this.props.option);
      delete opt.children;
      _this.props.onOptionClick(opt);
    });
    _defineProperty(_assertThisInitialized(_this), "getIndent", function (depth) {
      var onset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var padding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 8;
      return {
        paddingLeft: depth * LEFT_PADDING + padding + onset + 'px'
      };
    });
    _defineProperty(_assertThisInitialized(_this), "optionSelected", function (option) {
      return Array.isArray(_this.props.value) ? !!_this.props.value.find(function (o) {
        return Option.isSame(o, option);
      }) : false;
    });
    _defineProperty(_assertThisInitialized(_this), "onParentSelect", function (e) {
      if (!e.key || e.type === 'click' || e.type === 'keydown' && _keys.SUBMIT_KEYS.has(e.key)) {
        e.stopPropagation();
        e.preventDefault();
        return _this.onClickParent();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "selectOption", function (e, actions, option) {
      if (e.type === 'keydown' && _keys.SUBMIT_KEYS.has(e.key)) {
        e.preventDefault();
        actions.onOptionClick(option);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "renderOptionLabel", function () {
      var _this$props = _this.props,
        option = _this$props.option,
        renderOptionLabel = _this$props.renderOptionLabel;
      if (renderOptionLabel) return renderOptionLabel(option);
      return /*#__PURE__*/_react.default.createElement("span", {
        ref: _this.optionLabelRef,
        className: "sa-dropdown-options-option-label"
      }, option.label);
    });
    _defineProperty(_assertThisInitialized(_this), "wrapWithTooltip", function (text, children) {
      return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
        text: text,
        customWidth: true,
        className: "autoWidth"
      }, children);
    });
    return _this;
  }
  _createClass(Option, [{
    key: "render",
    value: function render() {
      var _option$children,
        _this2 = this,
        _option$children2;
      var _this$props$this$stat = _objectSpread(_objectSpread({}, this.props), this.state),
        option = _this$props$this$stat.option,
        expanded = _this$props$this$stat.expanded,
        depth = _this$props$this$stat.depth,
        onOptionRemove = _this$props$this$stat.onOptionRemove,
        onOptionAdd = _this$props$this$stat.onOptionAdd,
        actions = _objectWithoutProperties(_this$props$this$stat, _excluded);
      if (this.optionSelected(option)) return null;
      var toggleExpandLabel = "".concat(expanded ? 'Collapse' : 'Expand', " category \"").concat(option.label, "\"");
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (_option$children = option.children) !== null && _option$children !== void 0 && _option$children.length ?
      /*#__PURE__*/
      // if parent
      _react.default.createElement(_ConditionalWrapper.default, {
        condition: this.state.showTooltip,
        wrapper: function wrapper(children) {
          return _this2.wrapWithTooltip(option.label, children);
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: this.getIndent(depth - 1),
        className: (0, _classnames.default)({
          'sa-dropdown-options-option': true,
          expanded: expanded
        })
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        className: "icon-button",
        onKeyDown: this.onClickExpand,
        onClick: this.onClickExpand,
        title: toggleExpandLabel,
        "aria-label": toggleExpandLabel
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: expanded ? expandedIcon : collapsedIcon,
        alt: "Expand"
      })), /*#__PURE__*/_react.default.createElement("div", {
        role: "option",
        "aria-selected": this.optionSelected(option),
        tabIndex: this.props.selectParents ? 0 : -1,
        className: "option-button alt-font",
        onKeyDown: this.onParentSelect,
        onClick: this.onParentSelect,
        "data-testid": "option-depth-".concat(depth)
      }, this.renderOptionLabel()))) : this.optionSelected(option) ? null :
      /*#__PURE__*/
      // if child
      _react.default.createElement(_ConditionalWrapper.default, {
        condition: this.state.showTooltip,
        wrapper: function wrapper(children) {
          return _this2.wrapWithTooltip(option.label, children);
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: this.getIndent(depth - 1),
        className: (0, _classnames.default)({
          'sa-dropdown-options-option': true
        })
      }, /*#__PURE__*/_react.default.createElement("div", {
        role: "option",
        "aria-selected": this.optionSelected(option),
        tabIndex: 0,
        className: "option-button alt-font",
        onKeyDown: function onKeyDown(e) {
          return _this2.selectOption(e, actions, option);
        },
        onClick: function onClick() {
          return actions.onOptionClick(option);
        },
        "data-testid": "option-depth-".concat(depth)
      }, this.renderOptionLabel(), onOptionRemove && /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        className: "sa-dropdown-options-option remove",
        onClick: function onClick(e) {
          e.stopPropagation();
          return onOptionRemove(option, e);
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: plusOutline,
        className: "sa-dropdown-options-option remove-icon",
        title: "Remove",
        alt: "Remove"
      })), onOptionAdd && /*#__PURE__*/_react.default.createElement(_Button.default, {
        type: "button",
        className: "sa-dropdown-options-option add",
        onClick: function onClick(e) {
          e.stopPropagation();
          return onOptionAdd(option, e);
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: plusGreen,
        className: "sa-dropdown-options-option add-icon",
        title: "Add",
        alt: "Add"
      }))))), expanded && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (_option$children2 = option.children) === null || _option$children2 === void 0 ? void 0 : _option$children2.map(function (option, i) {
        return /*#__PURE__*/_react.default.createElement(Option, _extends({}, _this2.props, {
          depth: depth + 1,
          option: option,
          key: i
        }));
      })));
    }
  }]);
  return Option;
}(_react.PureComponent);
exports.default = Option;
_defineProperty(Option, "defaultProps", {
  depth: 1
});
_defineProperty(Option, "isSame", function (op1, op2) {
  if (op1.key) return op1.key === op2.key;
  return op1.label === op2.label;
});